<template>
    <div class="tab-content">
        <div class="tabs" @click="clickHandle($event)">
            <div
                class="tab"
                v-for="tab of tabs"
                :ref="tab.value"
                :class="{ selected: tab.selected }"
                :tabValue="tab.value"
                :key="tab.value"
            >
                {{ tab.text }}
            </div>
        </div>
        <div class="line" :style="{ width: lineWidth + 'px', left: lineLeft + 'px' }"></div>
    </div>
</template>

<script>
export default {
    props: ['tabs'],

    data() {
        return {
            lineWidth: 96,
            lineLeft: 473
        };
    },

    mounted() {
        const tabs = this.tabs;
        const selectedTab = tabs.find(t => t.selected);
        const firstTab = this.$refs[selectedTab.value][0];
        this.lineWidth = firstTab.offsetWidth;
        this.lineLeft = firstTab.offsetLeft;
    },

    methods: {
        clickHandle(event) {
            const ele = event.target;

            if (ele.classList.contains('tab')) {
                const tabs = this.tabs;
                const tabValue = ele.getAttribute("tabValue");
                const lastSelectedTab = tabs.find(t => t.selected);
                const selectedTab = tabs.find(t => t.value === tabValue);
                lastSelectedTab.selected = false;
                selectedTab.selected = true;
                this.lineWidth = ele.offsetWidth;
                this.lineLeft = ele.offsetLeft;
                this.$emit('setValue', ele.getAttribute('tabValue'));
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.tab-content {
    margin-bottom: 8px;
    .tabs {
        display: flex;
        align-items: center;

        .tab {
            font-size: 16px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 600;
            padding: 13px 32px;
            cursor: pointer;

            &.selected {
                color: #005299;
            }
        }
    }

    .line {
        position: absolute;
        margin-top: -2px;
        height: 2px;
        background: #005299;
        transition: all 0.3s ease-in-out;
    }
}
</style>
